import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Checkbox,
  IconButton,
  InputAdornment,
  Dialog,
  DialogContent,
  DialogContentText,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { v4 as uuidv4 } from "uuid";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Tick from "../../Assets/img/Profile/Tick-svg.svg";
import line81 from "../../Assets/img/Profile/line-8-1.svg";
import linkedin from "../../Assets/img/Profile/linkedin.png";
import microsoft from "../../Assets/img/Profile/google-logo-1.png";
import frame1 from "../../Assets/img/Profile/frame-1.svg";
import frame from "../../Assets/img/Profile/frame.png";
import frame2 from "../../Assets/img/Profile/frame-2.svg";
import frame3 from "../../Assets/img/Profile/frame-3.svg";
import Warning from "../../Assets/img/Profile/warning Sysmbol.svg";
import Sheet from "@mui/joy/Sheet";
import RadioGroup from "@mui/joy/RadioGroup";
// import videotutorial from '../../Assets/img/Profile/video-tutorials.png'
import Radio from "@mui/joy/Radio";
import { useMediaQuery } from "react-responsive";
import QrLogin from "./QrLogin";
import { GoogleLogin } from "react-google-login";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import InfoIcon from "@mui/icons-material/Info";
import Popover from "@mui/material/Popover";
import Captcha from "./Captcha";
import "../../Assets/css/main.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCardDetailsReducer,
  getAllCardInfoReducer,
  getVisitingCardReducer,
} from "../../Redux/Reducers/CardReducer";
import {
  getAwardsReducer,
  getCertificateReducer,
  getEducationReducer,
  getExperienceReducer,
  getPersonalHealthDocumentsReducer,
  getPersonalInfoReducer,
  getPersonalProfileFamilyReducer,
  getPersonalProfileHealthReducer,
  getPersonalProfileHobbiesReducer,
  getPersonalProfileLanguagesReducer,
  getProfessionalInfoReducer,
  getProfessionalSkillsReducer,
  getProfessionalSkillsResucer,
  getProjecteReducer,
  getRecommendationReducer,
  getResumeReducer,
  getServiceReducer,
  getVideoResumeReducer,
  postHealthBlobReducer,
} from "../../Redux/Reducers/ProfileReducer";
import { getOpenJobs } from "../../Redux/Reducers/JobReducer";
import { getAllFoldersReducer } from "../../Redux/Reducers/ContactReducer";
import ReplayIcon from "@mui/icons-material/Replay";
import { useQuantityContext } from "../QuantityContext";
import { getKycOcrApiReducer } from "../../Redux/Reducers/KycReducer";
import { GetEnterpriseCompanyList } from "../../Redux/Reducers/OnboardingReducer";
import { userOnboardByCreateLinkReducer } from "../../Redux/Reducers/EnterpriseReducer";
import { useLocation } from "react-router-dom";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0044c6",
    },
    background: {
      default: "#f5f7fa",
    },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

function Login({ showCaptcha }) {
  /* Speech Recognition*/
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;

  // At the top of your Login component — runs once when component mounts
  const searchParams = new URLSearchParams(window.location.search);
  const enterpriseParams = useRef({
    organizationId: searchParams.get('organizationId'),
    id: searchParams.get('id'),
    userType: searchParams.get('type'),
  });

  // const deepLinkURLPath = useSelector((state) => state?.onboarding?.deeplinkURL);
  // console.log("deepLinkURLPath-----", deepLinkURLPath);
  // console.log("Captured on mount:", enterpriseParams.current);
  const [micActive, setMicActive] = useState(false); // State for microphone activation
  const firstNameRef = useRef(null);
  const location = useLocation();
  const lastNameRef = useRef(null);
  const [micBlinkFirstName, setMicBlinkFirstName] = useState(false); // State for mic blinking (first name)
  const [micBlinkLastName, setMicBlinkLastName] = useState(false); // State for mic blinking (last name)
  const [micBlink, setMicBlink] = useState(false);
  const [Email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const storedRememberMe = localStorage.getItem("rememberMe") === "true";
  const [rememberMe, setRememberMe] = useState(storedRememberMe);
  const [termsAgreed, setTermsAgreed] = useState(true);
  const [mobileNumber, setMobileNumber] = useState("");
  const [registeredLoginId, setRegisteredLoginId] = useState({
    email: "",
  });
  const [FirstPageForgotPassword, setFirstPageForgotPassword] = useState(true);
  const [SecondPageForgotPassword, setSecondPageForgotPassword] =
    useState(false);
  const [ThirdPageForgotPassword, setThirdPageForgotPassword] = useState(false);
  const otpInputsRef = useRef([]);
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const [objectId, setobjectId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [accessToken, setAccessToken] = useState(null);

  const [sessionId, setSessionId] = useState(uuidv4()); // To send sessionID
  const [responseToken, setResponseToken] = useState(""); // To track the generated Token
  const [isVerified, setIsVerified] = useState(false); // Track if the token is verified
  const [isExpired, setIsExpired] = useState(false); // For any errors or expiry notice
  const [showPassword, setShowPassword] = useState(false);
  const [loginType, setloginType] = useState("web");

  const [selectedOption, setSelectedOption] = useState(null);
  const [isForgotPassword, setisForgotPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [code, setCode] = useState("");
  const [isDialogBoxOpen, setisDialofBoxOpen] = useState(false);
  const [TwoFactorAuthFirstPage, setTwoFactorAuthFirstPage] = useState(true);
  const [TwoFactorAuthSecondPage, setTwoFactorAuthSecondPage] = useState(false);
  const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  /* timer */
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0); // Change initial seconds value to 0
  const [showCode, setShowCode] = useState(true);
  const [showCodeError, setShowCodeError] = useState(false);
  const isSmallScreen = useMediaQuery({ maxWidth: 1199 });
  const isHamburger = useMediaQuery({ maxWidth: 992 });
  const [msalApp, setMsalApp] = useState(null); // State for MSAL instance
  const [initialized, setInitialized] = useState(false); // State to track initialization status
  const [validSubmitForgotPass, setvalidSubmitForgotPass] = useState(false);
  const [validVerifyCode, setValidVerifyCode] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [ShowPasswordError, setShowPasswordError] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isPageNotVerified, setIsPageNotVerified] = useState(false);
  const dispatch = useDispatch();
  const { openSnackbar } = useQuantityContext();
  const apiKey = process.env.REACT_APP_API_KEY; // actual API key
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "69420",
  };

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const organizationId = searchParams.get('organizationId');
  //   const id = searchParams.get('id');
  //   const userType = searchParams.get('type');
  //   // Store in localStorage
  //   if (organizationId) localStorage.setItem('organizationId', organizationId);
  //   if (id) localStorage.setItem('entityId', id);
  //   if (userType) localStorage.setItem('userType', userType);

  // }, [location.search]);


  const handleRememberChange = () => {
    setRememberMe(!rememberMe);
  };

  const handleCloseVerifiedDialog = () => {
    setIsVerifiedDialogOpen(false);
    setIsPageNotVerified(false);
    // setVerificationPageVisible(false);
    //? setShowProfessionalContent(true); Show professional content after closing the dialog
  };

  const homePageApi = () => {
    const promise = Promise.all([
      dispatch(getAllCardDetailsReducer()),
      dispatch(getAllCardInfoReducer()),
      dispatch(getPersonalInfoReducer()),
      dispatch(getProfessionalInfoReducer()),
      // useEffect(async () => {
      // dispatch(getPersonalInfoReducer()),
      // dispatch(getProfessionalInfoReducer()),
      dispatch(getPersonalProfileFamilyReducer()),
      dispatch(getPersonalProfileHobbiesReducer()),
      dispatch(getPersonalProfileLanguagesReducer()),
      dispatch(getPersonalProfileHealthReducer()),
      dispatch(getPersonalHealthDocumentsReducer()),
      dispatch(getVisitingCardReducer()),
      // dispatch(postHealthBlobReducer()),
      dispatch(getServiceReducer()),
      dispatch(getProjecteReducer()),
      dispatch(getAwardsReducer()),
      dispatch(getEducationReducer()),
      dispatch(getExperienceReducer()),
      dispatch(getCertificateReducer()),
      dispatch(getProfessionalSkillsReducer()),
      dispatch(getResumeReducer()),
      dispatch(getVideoResumeReducer()),
      dispatch(getKycOcrApiReducer()),
      dispatch(getRecommendationReducer()),
      dispatch(getOpenJobs()),
      dispatch(getAllFoldersReducer()),
      dispatch(GetEnterpriseCompanyList()),

      // }, [])
    ]);

    console.log("Promise from homePageApi:", promise);
    return promise;
  };

  const handleTermsChange = () => {
    setTermsAgreed(!termsAgreed);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleCodeChange = (event) => {
    setCode(event.target.value);
    setShowCodeError(false);
  };

  const toggleCodeVisibility = () => {
    setShowCode((prev) => !prev);
  };

  const handleCodeSubmit = () => {
    // setisDialofBoxOpen(false);
    // setTwoFactorAuthSecondPage(false);
    if (code.trim() === "") {
      setShowCodeError(true);
      return;
    }

    if (selectedOption === "email") {
      // Make API call to verify OTP
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`,
          {
            email: `${Email}`,
            otp: code,
          },
          {
            headers: headers,
          }
        )
        .then((response) => {
          setErrorMessage("");
          // console.log("OTP verified successfully");
          openSnackbar("OTP verified successfully", "success");
          localStorage.setItem("objectId", accessToken);
          homePageApi();
          setisDialofBoxOpen(false);
          setTwoFactorAuthSecondPage(false);
          setIsVerifiedDialogOpen(true);
        })
        .catch((error) => {
          // setIsPageNotVerified(true);
          setErrorMessage("Incorrect OTP. Please Retry.");
          console.error("Failed to verify OTP:", error);
        });
    } else {
      // Make API call to verify OTP via mobile
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorverify-mobile-otp`,
          {
            mobileNumber: `${mobileNumber}`,
            otp: parseInt(code),
          },
          {
            headers: headers,
          }
        )
        .then((response) => {
          setErrorMessage("");
          // console.log("Mobile OTP verified successfully");
          openSnackbar("Mobile OTP verified successfully", "success");
          localStorage.setItem("objectId", accessToken);
          homePageApi();
          setisDialofBoxOpen(false);
          setTwoFactorAuthSecondPage(false);
          setIsVerifiedDialogOpen(true);
        })
        .catch((error) => {
          // setIsPageNotVerified(true);
          setErrorMessage("Incorrect OTP. Please Retry.");
          console.error("Failed to verify mobile OTP:", error);
        });
    }
  };

  const handleUpdatePassword = async () => {
    if (newPassword !== confirmPassword) {
      setShowPasswordError(true);
      return;
    } else {
      setThirdPageForgotPassword(false);
      setisForgotPassword(false);

      // setIsSubmitted(false);
      try {
        setEmail(registeredLoginId.email);
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/onboarding/update-password`,
          {
            newPassword: newPassword,
            email: registeredLoginId.email,
          },
          {
            headers: headers,
          }
        );

        console.log("res of pass", response);
        if (response.status === 200) {
          // setobjectId(response.data.record._id);
          // await localStorage.setItem('objectId', response.data.record._id);
          // setMobileNumber(response.data.record.phoneNo);
          setTwoFactorAuthFirstPage(true);
          setisDialofBoxOpen(true);
          openSnackbar("Password updated successfully!", "success");
          handlecloseDialog();
        } else {
          toast.error("record not found ");
        }
      } catch (error) {
        console.error("Error updating password:", error);
      }
    }
  };

  const handleLogin = async (e) => {
    // localStorage.clear();
    // Save enterprise params BEFORE clearing
    const organizationId = localStorage.getItem('organizationId');
    const entityId = localStorage.getItem('entityId');
    const userType = localStorage.getItem('userType');
    const prevPath = localStorage.getItem('previousPath');

    localStorage.clear();

    // Restore all preserved values
    if (prevPath) localStorage.setItem('previousPath', prevPath);
    if (organizationId) localStorage.setItem('organizationId', organizationId);
    if (entityId) localStorage.setItem('entityId', entityId);
    if (userType) localStorage.setItem('userType', userType)
    setCode("");
    setErrorMessage("");
    setOtpValues(["", "", "", ""]);
    setSelectedOption(null);
    e.preventDefault();
    if (termsAgreed) {
      try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/users/login`,
          {
            email: Email,
            password: password,
            loginMetho: "Mobile",
            loginType: loginType,
          },
          {
            headers: headers,
          }
        );

        // console.log("login resp", response);

        if (response?.status === 200) {
          console.log("set if", response);
          //  toast.error(response.data.user._id)
          // Asynchronously set objectId
          const previousPath = localStorage.getItem("previousPath");
          if (!response?.data?.data?.accessToken) {
            toast.error(
              "Error: objectId is not set properly. Please try again."
            );
            return; // Exit the function
          }

          // Remove existing data in localStorage
          localStorage.removeItem("objectId"); // Remove specific item

          localStorage.removeItem("userDetails"); // Remove userDetails if necessary

          const prevPath = localStorage.getItem("previousPath");
          // localStorage.clear();
          if (prevPath) {
            localStorage.setItem("previousPath", prevPath);
          }

          setobjectId(response?.data?.data?.accessToken);
          // console.log("After setting the Object id", objectId);
          setAccessToken(response?.data?.data?.accessToken);
          // Call the userDetails API to set the details in localStorage
          const userResponse = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`,
            {
              headers: {
                ...headers,
                Authorization: `Bearer ${response?.data?.data?.accessToken}`,
                // "ngrok-skip-browser-warning": "69420"
              },
            }
          );

          // console.log("Home page data Megha", userResponse);
          const userData = userResponse?.data?.data?.user;
          // console.log("userDatauserData", userData);
          localStorage.setItem("userDetails", JSON.stringify(userData));

          // Check if objectId is set properly

          setMobileNumber(response?.data?.user.phone_no);
          setisDialofBoxOpen(true);
          setTwoFactorAuthFirstPage(true);
          setTwoFactorAuthSecondPage(false);
          // setIsVerifiedDialogOpen(true);
          console.log("resp data", response?.data);
          console.log(mobileNumber);
          console.log("Login successful:", response.data);
          // await handleEnterpriseDetails(userData);
          // openSnackbar("Login successfully!", "success")
          // Save token to local storage and redirect to dashboard
        } else if (response.status === 401) {
          openSnackbar("Email Id or Password is incorrect", "error");
          // toast.error("Email Id or Password is incorrect");
        }
      } catch (error) {
        console.log("login resp 2", error);

        // toast.error(error?.response?.data.message)
        openSnackbar(error?.response?.data.message, "error");
        console.error("Login failed:", error?.response?.data?.message);
      }
    } else {
      openSnackbar("Please agree to the terms and conditions.", "error");
      // toast.error("Please agree to the terms and conditions.");
    }
  };

  const handleClickForgotPassword = () => {
    setRegisteredLoginId("");
    setCode("");
    setOtpValues(["", "", "", ""]);
    setisForgotPassword(true);
    setFirstPageForgotPassword(true);
  };

  useEffect(() => {
    // Only start the timer if there is time left
    if (minutes === 0 && seconds === 0) {
      return;
    }

    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((prevSeconds) => prevSeconds - 1);
      } else if (minutes > 0) {
        setMinutes((prevMinutes) => prevMinutes - 1);
        setSeconds(59);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [minutes, seconds]);

  const handleForgotPassword = async (event) => {
    event.preventDefault();
    //  toast.error("Clicked");
    setvalidSubmitForgotPass(true);
    try {
      if (registeredLoginId.email.trim() !== "") {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/users/send-forgot-otp`,
          registeredLoginId,
          {
            headers: headers,
          }
        );
        console.log("Response:", response?.data);

        if (response?.status === 200) {
          setFirstPageForgotPassword(false);
          setSecondPageForgotPassword(true);
          setMinutes(0);
          setSeconds(60);
        } else if (response?.status === 204) {
          openSnackbar("User does not exist for this email ID", "error");
          // toast.error('User does not exist for this email ID');
          handlecloseDialog();
        } else {
          openSnackbar("An unexpected error occurred", "error");
          // toast.error('An unexpected error occurred');
        }
      }
    } catch (error) {
      openSnackbar("Error sending message:", "error");
      // console.error("Error sending message:", error);
    }
  };

  const handleInput = (index) => (e) => {
    setValidVerifyCode(false);
    const value = e.target.value;
    const maxLength = parseInt(e.target.getAttribute("maxlength"));
    const nextInput = otpInputsRef.current[index + 1];

    // Update the OTP values in the state array
    setOtpValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = value;
      return newValues;
    });

    if (value.length === maxLength && nextInput) {
      nextInput.focus();
    }
  };

  // const handleContinuetoDigital = async () => {
  //   setCode('');
  //   setOtpValues(['', '', '', '']);
  //   setSelectedOption(null);
  //   console.log("Object ID: " + objectId);

  //   if (objectId) {
  //     try {
  //       // Construct a URL object
  //       const url = new URL(`${process.env.REACT_APP_CARD_URL}/home`);

  //       // Append objectId as a query parameter to the URL object
  //       url.searchParams.append("objectId", objectId);

  //       // Redirect to the modified URL
  //       window.location.href = url.href;
  //     } catch (error) {
  //       console.error("Error setting objectId to URL parameter:", error);
  //        toast.error("Something went wrong");
  //     }
  //   } else {
  //      toast.error("objectId is missing");
  //   }
  // }

  const handleContinuetoDigital = async () => {
    setCode("");
    setOtpValues(["", "", "", ""]);
    setSelectedOption(null);
    console.log("Object ID: " + objectId);

    // if (!objectId) {
    try {
      const promiseApi = await homePageApi();
      console.log("Promise in the Login", promiseApi);
      if (promiseApi) {
        // await handleEnterpriseDetails()
        // return;
        // Replace history entry to prevent going back
        const previousPath = localStorage.getItem("previousPath");
        // Navigate to previous path or default to home
        const redirectPath = previousPath || `${process.env.REACT_APP_CARD_URL}/home`;

        // console.log("Redirect Path:", redirectPath);
        // Clean up the saved path
        localStorage.removeItem("previousPath");
        // Replace history entry and redirect
        // window.history.replaceState(null, "", redirectPath);
        // window.location.href = redirectPath;
        window.location.assign(redirectPath);

      }
      // Redirect to the /home URL directly
    } catch (error) {
      console.error("Error redirecting to /home:", error);
      // toast.error("Something went wrong");
      openSnackbar("Something went wrong", "error");
    }
    // } else {
    // openSnackbar("objectId is missing", "error")
    // toast.error("objectId is missing");
    // }
  };

  // Later when you have userRefId (after login), retrieve and send:
  // const handleEnterpriseDetails = () => {
  //   const organizationId = localStorage.getItem('organizationId');
  //   const id = localStorage.getItem('entityId');
  //   const userType = localStorage.getItem('userType');
  //   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  //   const userRefId = userDetails?.reference_id;

  //   console.log("organizationId", organizationId, "id", id, "userType", userType, "userDetails", userDetails, "userRefId", userRefId);
  //   if (organizationId && id && userType) {
  //     dispatch(userOnboardByCreateLinkReducer({
  //       organizationId: Number(organizationId),
  //       userRefId: userRefId,
  //       userType: userType,
  //       id: Number(id)
  //     }));

  //     // Clear after use
  //     localStorage.removeItem('organizationId');
  //     localStorage.removeItem('entityId');
  //     localStorage.removeItem('userType');
  //   }
  // };


  // const handleEnterpriseDetails = (userData) => {
  //   const { organizationId, id, userType } = enterpriseParams.current; // ✅ always available
  //   const userRefId = userData?.reference_id;

  //   console.log("organizationId", organizationId, "id", id, "userType", userType, "userRefId", userRefId);

  //   if (organizationId && id && userType && userRefId) {
  //     dispatch(userOnboardByCreateLinkReducer({
  //       organizationId: Number(organizationId),
  //       userRefId: userRefId,
  //       userType: userType,
  //       id: Number(id)
  //     }));
  //   }
  // };

  const handlecloseDialog = () => {
    setRegisteredLoginId("");
    setCode("");
    setOtpValues(["", "", "", ""]);
    setNewPassword("");
    setConfirmPassword("");
    setisForgotPassword(false);
    setFirstPageForgotPassword(false);
    setSecondPageForgotPassword(false);
    setThirdPageForgotPassword(false);
    setisDialofBoxOpen(false);
    setSelectedOption(null);
  };

  const [validNextFor2FA, setvalidNextFor2FA] = useState(false);
  const handleOptionChange = (event) => {
    setvalidNextFor2FA(false);
    setSelectedOption(event.target.value);
  };

  const handleAuthNextPage = () => {
    console.log(mobileNumber);
    setvalidNextFor2FA(true);
    if (selectedOption === "email") {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-send-otp`,
          {
            email: `${Email}`,
          },
          {
            headers: headers,
          }
        )
        .then((response) => {
          setTwoFactorAuthFirstPage(false);
          setTwoFactorAuthSecondPage(true);
          setMinutes(0);
          setSeconds(60);
          openSnackbar("OTP sent successfully", "success");
          // console.log("OTP sent successfully");
        })
        .catch((error) => {
          // Handle error, such as displaying an error message to the user
          // console.error("Failed to send OTP:", error);
          openSnackbar("Failed to send OTP", "error");
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorsend-mobile-otp`,
          {
            mobileNumber: `${mobileNumber}`,
          },
          {
            headers: headers,
          }
        )
        .then((response) => {
          setTwoFactorAuthFirstPage(false);
          setTwoFactorAuthSecondPage(true);
          setMinutes(0);
          setSeconds(60);
          // console.log("Mobile OTP sent successfully");
          openSnackbar("Mobile OTP sent successfully", "success");
        })
        .catch((error) => {
          openSnackbar("Failed to send mobile OTP", "error");
          // console.error("Failed to send mobile OTP:", error);
        });
    }
  };

  const resendOTP = async () => {
    setMinutes(0);
    setSeconds(60);
    if (selectedOption === "email") {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-send-otp`,
          {
            email: `${Email}`,
          },
          {
            headers: headers,
          }
        )
        .then((response) => {
          openSnackbar("OTP sent successfully", "success");
          // console.log("OTP sent successfully");
        })
        .catch((error) => {
          // Handle error, such as displaying an error message to the user
          openSnackbar("Failed to send OTP", "error");
          // console.error("Failed to send OTP:", error);
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactorsend-mobile-otp`,
          {
            mobileNumber: `${mobileNumber}`,
          },
          {
            headers: headers,
          }
        )
        .then((response) => {
          // console.log("Mobile OTP sent successfully");
          openSnackbar("Mobile OTP sent successfully", "success");
        })
        .catch((error) => {
          openSnackbar("Failed to send mobile OTP", "error");
          // console.error("Failed to send mobile OTP:", error);
        });
    }
  };

  const handleCodeSubmitPassword = async () => {
    const otp = parseInt(otpValues.join("")); // Concatenate OTP values and convert to number
    setValidVerifyCode(true);
    //  toast.error(otp);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/users/verify-forgot-otp`,
        {
          email: registeredLoginId?.email,
          otp: otp,
        },
        {
          headers: headers,
        }
      );
      localStorage.clear();
      console.log(response?.data?.message);
      setSecondPageForgotPassword(false);
      setThirdPageForgotPassword(true);
    } catch (error) {
      console.error("Error verifying email:", error);
      openSnackbar("Error verifying email. Please try again later.", "error");
      // toast.error('Error verifying email. Please try again later.');
    }
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const clientId =
    "60482953964-k5t7rkog4njbglmkeknkogt35epjiujd.apps.googleusercontent.com";

  const onFailure = (error) => {
    console.log("Login Failed:", error);
    // Handle failed login here
  };

  const handleGoogleLogin = () => {
    console.log("google sujccess");
  };

  const onSuccess = async (googleUser) => {
    console.log("Login Success:", googleUser.profileObj.email);
    if (googleUser.profileObj.email) {
      console.log("Email Id 1 is", googleUser.profileObj.email); // Corrected Email access
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/users/mailid/userDetails`,
          { email: googleUser.profileObj.email },
          { headers: headers }
        ); // Corrected Email access
        if (response.status === 200) {
          // Extract phone number from response data
          const phoneNo = response?.data?.phoneNo.phone_no;
          console.log("objid", response?.data?.accessToken);
          console.log("PhoneNo is", phoneNo);
          console.log("Email id 2 is ", googleUser?.profileObj?.email);

          setobjectId(response?.data?.accessToken);
          localStorage.setItem("objectId", response?.data?.accessToken);
          setMobileNumber(phoneNo);
          setEmail(googleUser?.profileObj?.email);
          setTwoFactorAuthFirstPage(true);
          setisDialofBoxOpen(true);
        } else if (response.status === 204) {
          // toast.error("Email id is not exist")
          openSnackbar("Email id is not exist", "error");
        } else {
          // Throw an error if the response is not successful
          throw new Error("Failed to fetch user details");
        }
      } catch (error) {
        // Handle any errors
        console.error("Error fetching user details:", error);
        return null;
      }
    }
  };

  const handleLoginmicro = async () => {
    if (!initialized || !msalApp) {
      console.error("MSAL app is not initialized.");
      return;
    }

    try {
      await msalApp.loginPopup({
        scopes: ["user.read"],
        prompt: "select_account",
        interactionType: InteractionType.Popup,
      });
      const accounts = await msalApp.getAllAccounts();
      console.log("accounts of micro", accounts);

      if (accounts.length > 0) {
        // setEmail(accounts[0].username);
        setEmail(accounts[0].username.toLowerCase());
        console.log("Email Id is", Email);
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/mail/mailid/userDetails`,
            { email: accounts[0].username.toLowerCase() },
            {
              headers: headers,
            }
          );
          console.log(response);
          if (response.status === 200) {
            // Extract phone number from response data
            const phoneNo = response?.data?.phoneNo.phoneNo;
            console.log("obg micro", response?.data?.phoneNo._id);
            console.log("PhoneNo is", phoneNo);
            setMobileNumber(phoneNo);
            setobjectId(response?.data?.phoneNo._id);
            await localStorage.setItem("objectId", response?.data?.phoneNo._id);
            setTwoFactorAuthFirstPage(true);
            setisDialofBoxOpen(true);
          } else if (response.status === 204) {
            openSnackbar("Email id is not exist", "error");
            // toast.error("Email id is not exist")
          } else {
            // Throw an error if the response is not successful
            throw new Error("Failed to fetch user details");
          }
        } catch (error) {
          // Handle any errors
          openSnackbar("Error fetching user details:", "error");
          // console.error('Error fetching user details:', error);
          return null;
        }
      }
    } catch (error) {
      console.log("Login failed:", error);
    }
  };

  const handleMicClick = (fieldRef, setMicBlink) => {
    console.log("Mic clicked");
    setMicActive(true); // Activate the microphone
    fieldRef.current.focus(); // Focus on the text field
    setMicBlink(true);
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = ["en-US"];

    const onFocusChange = () => {
      if (document.activeElement !== fieldRef.current) {
        recognition.stop();
        setMicActive(false);
        setMicBlink(false);
      }
    };
    recognition.onresult = (event) => {
      const transcript = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");

      // Update the appropriate text field based on the active element
      if (document.activeElement) {
        const activeElementId = document.activeElement.id;
        if (activeElementId === "neoinId") {
          setEmail(transcript);
        }
      }
    };

    recognition.onend = () => {
      setMicBlink(false); // Stop blinking when speech recognition ends
    };

    fieldRef.current.addEventListener("blur", onFocusChange);
    recognition.start();
  };

  const open = Boolean(anchorEl);

  const handleRetrybutton = () => {
    setCode("");
    setOtpValues(["", "", "", ""]);
    setSelectedOption(null);
  };

  useEffect(() => {
    const storedUsername = localStorage.getItem("email");
    const storedPassword = localStorage.getItem("password");

    if (storedUsername && storedPassword) {
      setEmail(storedUsername);
      setPassword(storedPassword);
    }

    const sendMobileToken = async () => {
      if (!sessionId) {
        const newUuid = uuidv4();
        setSessionId(newUuid);
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/users/api/generate-token`,
          {
            method: "POST",
            headers: {
              "x-api-key": process.env.REACT_APP_API_KEY,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ sessionId: sessionId }), // Convert sessionId to JSON
          }
        );
        if (!response.ok) {
          throw new Error("Failed to generate token");
        }
        const responseData = await response.json();
        if (responseData?.status === "SUCCESS") {
          const tokenResponse = responseData?.data?.token;
          console.log("responseToken:", tokenResponse);
          setResponseToken(tokenResponse);
        } else {
          console.error("Error in response: ", responseData?.message);
        }
      } catch (error) {
        console.log("Error generating Token in Login", error);
      }
    };
    sendMobileToken();
  }, []);

  // Function to poll for token status
  const checkTokenStatus = async (token) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/users/api/check-token-status/${token}`,
        {
          method: "GET",
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "Content-Type": "application/json",
          },
        }
      );
      const responseData = await response.json();
      if (responseData?.status === "SUCCESS" && responseData?.data?.verified) {
        setobjectId(responseData?.data?.accessToken);
        localStorage.setItem("objectId", responseData?.data?.accessToken);
        setIsVerified(true); // Set verified status
        // Wait for the objectId and userDetails to be set and then call handleContinuetoDigital
        const userResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`,
          {
            headers: {
              ...headers,
              Authorization: `Bearer ${responseData?.data?.accessToken}`,
            },
          }
        );

        // console.log("userResponseuserResponse", userResponse);
        const userData = userResponse?.data?.data?.user;
        // console.log("HOME PAGE DATA", userData);
        localStorage.setItem("userDetails", JSON.stringify(userData));

        // homePageApi();
        setTimeout(() => {
          handleContinuetoDigital(); // Call the redirection function
        }, 0); // Ensure it runs after the objectId is set
        return true;
      }
      return false;
    } catch (error) {
      console.log("Error checking token status:", error);
    }
  };

  useEffect(() => {
    if (responseToken) {
      const pollInterval = 5000; // Poll every 5 seconds
      const expirationTime = 5 * 60 * 1000; // Token valid for 5 minutes
      let pollTimeout = null;

      // Function to poll for token status
      const pollTokenStatus = () => {
        if (!isExpired) {
          // Poll only if token is not expired and not verified yet
          checkTokenStatus(responseToken)
            .then((verified) => {
              // if (verified) {
              //   console.log('Token verified, redirecting to Home page...');
              //   handleContinuetoDigital(); // Redirect when verified
              // } else
              if (!verified) {
                // Continue polling if not verified and not expired
                pollTimeout = setTimeout(pollTokenStatus, pollInterval);
              }
            })
            .catch((error) => {
              console.log("Error polling responseToken", error);
            });
        }
      };

      // Start polling immediately
      pollTokenStatus();

      // Stop polling after the token expires
      const expirationTimer = setTimeout(() => {
        setIsExpired(true);
        setResponseToken(null); // Clear the token after expiration
        clearTimeout(pollTimeout); // Ensure polling stops once expired
      }, expirationTime);

      // Cleanup timeout on component unmount
      return () => {
        clearTimeout(expirationTimer);
        clearTimeout(pollTimeout); // Cleanup polling timeout as well
      };
    }
  }, [responseToken, isExpired, isVerified]); // Ensure useEffect runs on isVerified changes

  const handleQRcodeRefresh = () => {
    window.location.reload();
  };


  return (
    <>
      <div className="login-in">
        {isHamburger ? (
          <>
            <div className="d-flex flex-column align-items-center py-2">
              <div className="welcome-to-neoin">Welcome to Neoin</div>
              {/* <div className="text-wrapper-2">Lets get started</div> */}
              <p className="p-tag mt-0">
                Unlock a world of possibilities, securely
              </p>
              <div className="center-container">
                <div className="overlap-group-wrapper">
                  <div className="overlap-group-2">
                    {/* <img className="trailing-icon" src={trailing} alt='trailing' /> */}
                    {/* <TextField
                className="text-field-outline input-text"
                id="neoinId"
                name="neoinId"
                label="Neoin ID"
                variant="outlined"
              />
              <IconButton className="trailing-icon"><MicIcon /></IconButton> */}
                    <TextField
                      inputRef={firstNameRef}
                      className="text-field-outline input-text neoinId"
                      id="neoinId"
                      name="neoinId"
                      label="Neoin iD"
                      variant="outlined"
                      required
                      value={Email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    // enabled={micActive}
                    />
                    {/* <IconButton
                className={`trailing-icon ${micBlinkFirstName ? "blink" : ""}`}
                onClick={() => handleMicClick(firstNameRef, setMicBlinkFirstName)}
              >
                <MicIcon />
              </IconButton> */}
                  </div>
                </div>
                <div className="overlap-group-wrapper">
                  <div className="overlap-group-2">
                    <TextField
                      className="text-field-outline input-text"
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      label="Password"
                      variant="outlined"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        // setFirstNameError(false);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={togglePasswordVisibility}>
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="black-color-2">
                    <Checkbox
                      checked={rememberMe}
                      onChange={handleRememberChange}
                    />{" "}
                    Remember
                  </div>

                  <a
                    href="#"
                    className="input-text-3"
                    onClick={handleClickForgotPassword}
                  >
                    Forgot Password?
                  </a>
                </div>

                <div className="black-color">
                  <Checkbox
                    checked={termsAgreed}
                    onChange={handleTermsChange}
                  />
                  I agree to the{" "}
                  <span className="color-blue">
                    Terms & Conditions | Privacy Policy
                  </span>
                </div>
                <div className="element-contained-a-text-wrapper mb-20">
                  <Button
                    variant="contained"
                    className={`btn btn-primary`}
                    onClick={handleLogin}
                    sx={{ width: "100%" }}
                  >
                    LOGIN
                  </Button>

                  {/* <button className="custom-buttom element-contained-a-text" onClick={handleLogin}>
              <div className="text">
                <div className="label">LOGIN</div>
              </div>
            </button> */}
                </div>
              </div>

              <div className="overlap-wrapper">
                <div className="overlap-3">
                  <img className="line-2" src={line81} alt="line" />
                  <div className="rectangle-2"></div>
                  <div className="text-wrapper-5">Or</div>
                </div>
              </div>

              <div className="overlap-6">
                <div className="group-2 d-flex align-items-center">
                  {responseToken && <QrLogin uid={responseToken} />}
                  {isExpired && (
                    <div style={{ color: "red", fontSize: "13px" }}>
                      {" "}
                      QR Code expired. Please Reload.
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <ReplayIcon onClick={handleQRcodeRefresh} />
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <div className="scan-this-with-neoin word-break mb-3">
                    Scan this with Neoin app to log in instantly
                  </div>
                  <div className="text-wrapper-6">Login with QR Code</div>
                  {/* <img className="group-2" src={group4} alt='group' />*/}
                </div>
              </div>

              <div className="overlap-wrapper">
                <div className="overlap-3 mt-30">
                  <img className="line-2" src={line81} alt="line" />
                  <div className="rectangle-2"></div>
                  <div className="text-wrapper-5">Or</div>
                </div>
              </div>

              {/* <div className='login-with-account'> */}
              {/* <div className="d-flex justify-content-center">
            <div className="login-with-google">
              <div className="overlap-5">
                <div className="login-with-google-2">Login with Google</div>
                <img className="google-logo" src={google} alt='google' />
              </div>
            </div>
          </div> */}

              {/* <div className="d-flex justify-content-center">
                <div className="login-with-google" onClick={handleGoogleLogin}>
                  <GoogleLogin
                    clientId={clientId}
                    buttonText="Login with Google"
                    onSuccess={onSuccess}
                    onFailure={onFailure}
                    cookiePolicy={'single_host_origin'}
                    style={{ display: 'none' }} // Hide the actual Google login button

                  />
                </div>
              </div> */}
              {/* 
          <div className="d-flex justify-content-center">
            <div className="div-wrapper mt-3">
              <div className="overlap-5">
                <div className="login-with-google-2">Login with Microsoft</div>
                <img className="google-logo" src={microsoft} alt='microsoft' />
              </div>
            </div>
          </div> */}

              {/* <div onClick={handleLoginmicro} className="d-flex justify-content-center cursorshow">
                <div className="div-wrapper mt-3">
                  <div className="overlap-5">
                    <div className="login-with-google-2">Login with Microsoft</div>
                    <img className="google-logo" src={microsoft} alt='microsoft' />
                  </div>
                </div>
              </div> */}

              {/* <div className="d-flex justify-content-center cursorshow">
                <div className="login-with-facebook mt-3">
                  <div className="overlap-4">
                    <img className="google-logo" src={linkedin} alt='linkedin' />
                    <div className="login-with-facebook-2">Login with Linkedin</div>
                  </div>
                </div>
              </div>
            </div> */}
              <div className="create-neoin">
                New to Neoin?{" "}
                <a href="/welcome" className="span">
                  Create ID now
                </a>
              </div>

              <div className="text-wrapper-3 text-center">Follow us on</div>
              <div >
                <div className="social-media text-center">
                  <a href="/comingsoon">
                    <img className="" src={frame} alt="frame" />
                  </a>
                  <a href="https://sg.linkedin.com/company/neoinco">
                    <img className="" src={frame1} alt="frame" />
                  </a>
                  <a href="/comingsoon">
                    <img className="" src={frame2} alt="frame" />
                  </a>
                  <a href="https://www.youtube.com/@NEOIN-DALOCAL">
                    <img className="" src={frame3} alt="frame" />
                  </a>
                </div>
              </div>

              <p className="element-by-neoin-design text-center">
                © 2025 by Neoin. Design &amp; Developed by Neoin
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="row newcontainer">
              <div
                className={
                  isSmallScreen
                    ? "col-7 group1 login-bg-img"
                    : "col-7 group1 login-bg-img"
                }
              >
                {/* <div className='login-with-account'>

                    <div className="d-flex justify-content-center">
                      <div className="login-with-google" onClick={handleGoogleLogin}>
                        <GoogleLogin
                          clientId={clientId}
                          buttonText="Login with Google"
                          onSuccess={onSuccess}
                          onFailure={onFailure}
                          cookiePolicy={'single_host_origin'}
                          style={{ width: "100%" }} // Hide the actual Google login button

                        />
                      </div>
                    </div>

                    <div onClick={handleLoginmicro} className="d-flex justify-content-center cursorshow">
                      <div className="div-wrapper mt-3">
                        <div className="overlap-5">
                          <div className="login-with-google-2">Login with Microsoft</div>
                          <img className="google-logo" src={microsoft} alt='microsoft' />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center cursorshow">
                      <div className="login-with-facebook mt-3">
                        <div className="overlap-4">
                          <img className="google-logo" src={linkedin} alt='linkedin' />
                          <div className="login-with-facebook-2">Login with Linkedin</div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                {/* <div className='create-neoin'>New to Neoin? <a href='/welcome' className="span">Create ID now</a></div>

                <div className="text-wrapper-3 text-center">Follow us on</div>
                <div className="social-media text-center">
                  <div>
                    <a href="/comingsoon">
                      <img className="width-image" src={frame} alt='frame' />
                    </a>
                    <a href="https://sg.linkedin.com/company/neoinco">
                      <img className="width-image" src={frame1} alt='frame' />
                    </a>
                    <a href="/comingsoon">
                      <img className="width-image" src={frame2} alt='frame' />
                    </a>
                    <a href="https://www.youtube.com/@NEOIN-DALOCAL">
                      <img className="width-image" src={frame3} alt='frame' />
                    </a>
                  </div>
                </div>

                <p className="element-by-neoin-design text-center">© 2025 by Neoin. Design &amp; Developed by Neoin</p> */}
              </div>

              <div className={isSmallScreen ? "col-5 group1" : "col-5 group1"}>
                <div className="d-flex flex-column align-items-center">
                  <div className="welcome-to-neoin">Welcome to Neoin</div>
                  {/* <div className="text-wrapper-2">Lets get started</div> */}
                  <p className="p-tag mt-0">
                    Unlock a world of possibilities, securely
                  </p>
                  <div>
                    <form>
                      <div className="overlap-group-wrapper">
                        <div className="overlap-group-2">
                          <TextField
                            inputRef={firstNameRef}
                            className="text-field-outline input-text neoinId"
                            id="neoinId"
                            name="neoinId"
                            label="Neoin iD"
                            variant="outlined"
                            required
                            value={Email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                            }}
                            enabled={micActive}
                          />
                          {/* <IconButton
                        className={`trailing-icon ${micBlinkFirstName ? "blink" : ""}`}
                        onClick={() => handleMicClick(firstNameRef, setMicBlinkFirstName)}
                      >
                        <MicIcon />
                      </IconButton> */}
                        </div>
                      </div>

                      <div className="overlap-group-wrapper">
                        <div className="overlap-group-2">
                          <TextField
                            className="text-field-outline input-text"
                            id="password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            label="Password"
                            variant="outlined"
                            value={password}
                            onChange={(e) => {
                              setPassword(e.target.value);
                              // setFirstNameError(false);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={togglePasswordVisibility}
                                  >
                                    {showPassword ? (
                                      <VisibilityIcon />
                                    ) : (
                                      <VisibilityOffIcon />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <div className="black-color">
                          <Checkbox
                            checked={rememberMe}
                            onChange={handleRememberChange}
                          />{" "}
                          Remember
                        </div>

                        <a
                          href="#"
                          className="input-text-3"
                          onClick={handleClickForgotPassword}
                        >
                          Forgot Password?
                        </a>
                      </div>

                      <div className="black-color">
                        <Checkbox
                          checked={termsAgreed}
                          onChange={handleTermsChange}
                        />
                        I agree to the{" "}
                        <span className="color-blue">
                          Terms & Conditions | Privacy Policy
                        </span>
                      </div>

                      <div className="element-contained-a-text-wrapper mb-10">
                        <Button
                          variant="contained"
                          className={`btn btn-primary`}
                          onClick={handleLogin}
                          sx={{ width: "100%" }}
                        >
                          LOGIN
                        </Button>
                      </div>
                    </form>
                  </div>

                  <div className="overlap-wrapper">
                    <div className="overlap-3">
                      <img className="line-2" src={line81} alt="line" />
                      <div className="rectangle-2"></div>
                      <div className="text-wrapper-5">Or</div>
                    </div>
                  </div>

                  {/* <div className="group-new"> */}
                  <div className="overlap-6">
                    <div className="group-2 d-flex align-items-center">
                      {responseToken && <QrLogin uid={responseToken} />}
                      {isExpired && (
                        <div style={{ color: "red", fontSize: "13px" }}>
                          {" "}
                          QR Code expired. Please Reload.
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <ReplayIcon onClick={handleQRcodeRefresh} />
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="scan-this-with-neoin word-break mb-3">
                        Scan this with Neoin app to log in instantly
                      </div>
                      <div className="text-wrapper-6">Login with QR Code</div>
                      {/* <img className="group-2" src={group4} alt='group' />*/}
                    </div>
                  </div>
                  {/* </div> */}

                  <div className="create-neoin">
                    New to Neoin?{" "}
                    <a href="/welcome" className="span">
                      Create ID now
                    </a>
                  </div>

                  <div className="text-wrapper-3 text-center">Follow us on</div>
                  <div>
                    <div className="social-media text-center">
                      <a href="/comingsoon">
                        <img className="width-image" src={frame} alt="frame" />
                      </a>
                      <a href="https://sg.linkedin.com/company/neoinco">
                        <img className="width-image" src={frame1} alt="frame" />
                      </a>
                      <a href="/comingsoon">
                        <img className="width-image" src={frame2} alt="frame" />
                      </a>
                      <a href="https://www.youtube.com/@NEOIN-DALOCAL">
                        <img className="width-image" src={frame3} alt="frame" />
                      </a>
                    </div>
                  </div>

                  <p className="element-by-neoin-design text-center">
                    © 2025 by Neoin. Design &amp; Developed by Neoin
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {isForgotPassword && (
          <Dialog
            open={isForgotPassword}
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="Forgot Password"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
            BackProps={{
              style: { backgroundColor: "red" }, // Set your desired background color here
            }}
          >
            <DialogContent className="dialogContainer1">
              <DialogContentText className="dialogText">
                {FirstPageForgotPassword && (
                  <div>
                    <p className="mt-10 onboard_header_align color-blue">
                      Forgot your Password?
                    </p>
                    <p className="paragraph-text-dialog mb-4 text-center">
                      Enter your Registered Email to reset password
                    </p>
                    <button
                      type="button"
                      className="lightbox__close"
                      onClick={handlecloseDialog}
                    >
                      &times;
                    </button>

                    <form className="mt-30">
                      <TextField
                        className="text-field-outline input-text neoinId"
                        id="registered_neoinId"
                        name="registered_neoinId"
                        label="Enter registered Login ID"
                        variant="outlined"
                        required
                        value={registeredLoginId.email}
                        onChange={(e) => {
                          setvalidSubmitForgotPass(false);
                          setRegisteredLoginId({
                            ...registeredLoginId,
                            email: e.target.value,
                          });
                        }}
                      />
                      <div className="justify-content-flex-end">
                        <div className="next-button-container">
                          <Button
                            variant="contained"
                            // color="primary"
                            type="submit"
                            onClick={handleForgotPassword}
                            disabled={
                              registeredLoginId.email?.trim() === "" ||
                              validSubmitForgotPass
                            }
                            className={`btn btn-primary ${registeredLoginId.email?.trim() === "" ||
                              validSubmitForgotPass
                              ? "disabled"
                              : ""
                              }`}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                {/* {FirstPageForgotPassword && ( */}
                {SecondPageForgotPassword && (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                  }}>
                    <div style={{
                      width: '90%',
                      maxWidth: '440px',
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      padding: '32px',
                      position: 'relative',
                      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
                    }}>

                      {/* Close Button */}
                      <button
                        onClick={handlecloseDialog}
                        style={{
                          position: 'absolute',
                          top: '20px',
                          right: '20px',
                          background: 'none',
                          border: 'none',
                          fontSize: '24px',
                          cursor: 'pointer',
                          color: '#999',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: 0
                        }}
                      >
                        ×
                      </button>

                      {/* Title */}
                      <h2 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        color: '#000',
                        margin: '0 0 8px 0'
                      }}>
                        Enter verification code
                      </h2>

                      {/* Subtitle */}
                      <p style={{
                        fontSize: '14px',
                        color: '#666',
                        margin: '0 0 28px 0',
                        lineHeight: '1.5'
                      }}>
                        Please enter the 4-digit code sent to<br />
                        your registered email
                      </p>

                      {/* OTP Input */}
                      <div style={{ marginBottom: '28px' }}>
                        <div style={{
                          fontSize: '14px',
                          fontWeight: '500',
                          color: '#333',
                          marginBottom: '8px'
                        }}>
                          Enter verification code *
                        </div>
                        <input
                          type="text"
                          maxLength="4"
                          placeholder="••••"
                          value={otpValues.join('')}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
                            // Update otpValues array
                            for (let i = 0; i < 4; i++) {
                              otpValues[i] = value[i] || '';
                            }
                            // Force re-render by updating state (if you have a setter)
                            if (typeof setOtpValues === 'function') {
                              setOtpValues([...otpValues]);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && otpValues.every(v => v)) {
                              handleCodeSubmitPassword();
                            }
                          }}
                          style={{
                            width: '100%',
                            height: '48px',
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                            fontSize: '20px',
                            fontWeight: '500',
                            textAlign: 'center',
                            letterSpacing: '8px',
                            color: '#333',
                            outline: 'none',
                            padding: '0 12px',
                            boxSizing: 'border-box',
                            fontFamily: 'monospace'
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = '#0044C6';
                            e.target.style.outline = 'none';
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = '#ccc';
                          }}
                          autoFocus
                        />
                      </div>

                      {/* Timer and Resend */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '28px'
                      }}>
                        <div style={{
                          fontSize: '14px',
                          color: '#666'
                        }}>
                          {minutes > 0 || seconds > 0 ? (
                            <>Code expires in: <span style={{ fontWeight: '600', color: '#0044C6' }}>
                              {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
                            </span></>
                          ) : (
                            <span style={{ color: '#dc3545' }}>Code expired</span>
                          )}
                        </div>

                        <button
                          onClick={handleForgotPassword}
                          disabled={minutes > 0 || seconds > 0}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: minutes > 0 || seconds > 0 ? '#999' : '#0044C6',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: minutes > 0 || seconds > 0 ? 'not-allowed' : 'pointer',
                            padding: '4px 8px',
                            textDecoration: 'underline'
                          }}
                        >
                          RESEND
                        </button>
                      </div>

                      {/* Submit Button */}
                      <button
                        onClick={handleCodeSubmitPassword}
                        disabled={!otpValues.every(v => v)}
                        style={{
                          width: '100%',
                          padding: '12px',
                          backgroundColor: !otpValues.every(v => v) ? '#ccc' : '#0044C6',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '16px',
                          fontWeight: '500',
                          cursor: !otpValues.every(v => v) ? 'not-allowed' : 'pointer',
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          if (otpValues.every(v => v)) {
                            e.target.style.backgroundColor = '#0033a0';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (otpValues.every(v => v)) {
                            e.target.style.backgroundColor = '#0044C6';
                          }
                        }}
                      >
                        SUBMIT
                      </button>
                    </div>
                  </div>
                )}
                {ThirdPageForgotPassword && (
                  <div style={{
                    width: '400px',
                    margin: '0 auto',
                    padding: '24px',
                    background: 'white',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    position: 'relative'
                  }}>
                    {/* Header */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '24px',
                      paddingBottom: '16px',
                      borderBottom: '1px solid #e0e0e0'
                    }}>
                      <p style={{
                        fontSize: '24px',
                        fontWeight: 600,
                        color: '#333',
                        margin: 0
                      }}>
                        Update Password
                      </p>
                      <button
                        type="button"
                        onClick={handlecloseDialog}
                        style={{
                          background: 'none',
                          border: 'none',
                          fontSize: '28px',
                          cursor: 'pointer',
                          color: '#666',
                          padding: '0 8px',
                          lineHeight: 1
                        }}
                        aria-label="Close"
                      >
                        &times;
                      </button>
                    </div>

                    {/* Password Requirements Info */}
                    <div style={{ marginBottom: '24px' }}>
                      <div
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          padding: '4px 8px',
                          backgroundColor: '#f5f5f5',
                          borderRadius: '4px',
                          cursor: 'default'
                        }}
                      >
                        <span style={{ fontSize: '14px', color: '#666' }}>
                          Secure your neoin Id
                        </span>
                        <InfoIcon style={{ width: '18px', height: '18px', color: '#999' }} />
                      </div>

                      <Popover
                        id="mouse-over-popover"
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        disableRestoreFocus
                        sx={{
                          pointerEvents: "none",
                          mt: 1,
                          '& .MuiPopover-paper': {
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                          }
                        }}
                      >
                        <div style={{
                          padding: '16px',
                          minWidth: '240px'
                        }}>
                          <p style={{
                            margin: '0 0 12px 0',
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#333'
                          }}>
                            Password must contain:
                          </p>
                          <ul style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0
                          }}>
                            {[
                              { text: 'At least 8 characters', test: newPassword?.length >= 8 },
                              { text: 'At least one lowercase letter', test: /[a-z]/.test(newPassword) },
                              { text: 'At least one uppercase letter', test: /[A-Z]/.test(newPassword) },
                              { text: 'At least one number or symbol', test: /[0-9!@#$%^&*]/.test(newPassword) }
                            ].map((req, index) => (
                              <li key={index} style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginBottom: '8px',
                                fontSize: '13px',
                                color: req.test ? '#4caf50' : '#999'
                              }}>
                                <span style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '16px',
                                  height: '16px',
                                  borderRadius: '50%',
                                  backgroundColor: req.test ? '#4caf50' : '#e0e0e0',
                                  color: 'white',
                                  fontSize: '12px'
                                }}>
                                  ✓
                                </span>
                                {req.text}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Popover>
                    </div>

                    {/* Password Fields */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '20px',
                      marginBottom: '24px'
                    }}>
                      <TextField
                        style={{ width: '100%' }}
                        id="new-password"
                        name="newPassword"
                        type={showNewPassword ? "text" : "password"}
                        label="New Password"
                        error={ShowPasswordError}
                        variant="outlined"
                        value={newPassword}
                        onChange={(e) => {
                          setShowPasswordError(false);
                          setNewPassword(e.target.value);
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={toggleNewPasswordVisibility}
                                edge="end"
                                style={{ padding: '8px' }}
                              >
                                {showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                              </IconButton>
                            </InputAdornment>
                          ),
                          style: { borderRadius: '8px' }
                        }}
                      />

                      <TextField
                        style={{ width: '100%' }}
                        id="confirm-password"
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        label="Confirm Password"
                        error={ShowPasswordError || (confirmPassword && newPassword !== confirmPassword)}
                        helperText={
                          confirmPassword && newPassword !== confirmPassword
                            ? "Passwords don't match"
                            : ""
                        }
                        variant="outlined"
                        value={confirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          setShowPasswordError(false);
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={toggleConfirmPasswordVisibility}
                                edge="end"
                                style={{ padding: '8px' }}
                              >
                                {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                              </IconButton>
                            </InputAdornment>
                          ),
                          style: { borderRadius: '8px' }
                        }}
                      />
                    </div>

                    {/* Error Message */}
                    {ShowPasswordError && (
                      <div style={{
                        padding: '12px 16px',
                        backgroundColor: '#ffebee',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        <span style={{ color: '#c62828', fontSize: '14px' }}>
                          ⚠️ Please check password requirements
                        </span>
                      </div>
                    )}

                    {/* Update Button */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'flex-end'
                    }}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={handleUpdatePassword}
                        disabled={
                          !newPassword?.trim() ||
                          !confirmPassword?.trim() ||
                          newPassword !== confirmPassword ||
                          newPassword?.length < 8 ||
                          !/[a-z]/.test(newPassword) ||
                          !/[A-Z]/.test(newPassword) ||
                          !/[0-9!@#$%^&*]/.test(newPassword)
                        }
                        style={{
                          padding: '10px 32px',
                          backgroundColor: '#1976d2',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: 600,
                          cursor: 'pointer',
                          transition: 'background-color 0.2s',
                          opacity: (
                            !newPassword?.trim() ||
                            !confirmPassword?.trim() ||
                            newPassword !== confirmPassword ||
                            newPassword?.length < 8 ||
                            !/[a-z]/.test(newPassword) ||
                            !/[A-Z]/.test(newPassword) ||
                            !/[0-9!@#$%^&*]/.test(newPassword)
                          ) ? 0.6 : 1,
                          ':hover': {
                            backgroundColor: '#1565c0'
                          }
                        }}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.disabled) {
                            e.currentTarget.style.backgroundColor = '#1565c0';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.disabled) {
                            e.currentTarget.style.backgroundColor = '#1976d2';
                          }
                        }}
                      >
                        UPDATE
                      </Button>
                    </div>
                  </div>
                )}
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}

        {isDialogBoxOpen && (
          <Dialog
            open={isDialogBoxOpen}
            // onClose={handleCloseVerifiedDialog}
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="Enable 2FA (Two-factor Authentication)"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent className="dialogContainer">
              {/* <DialogContentText className="dialogText"> */}
              <div>
                <p className="mt-10 onboard_header_align">
                  Enable 2FA (Two-factor Authentication)
                </p>
                <p className="paragraph-text">Choose the Method </p>
                <button
                  type="button"
                  className="lightbox__close"
                  onClick={handlecloseDialog}
                >
                  &times;
                </button>

                {TwoFactorAuthFirstPage && !TwoFactorAuthSecondPage && (
                  <>
                    <div className="justify-content-center-login">
                      <Sheet
                        variant="outlined"
                        sx={{
                          boxShadow: "sm",
                          borderRadius: "sm",
                          marginBottom: 2,
                          p: 1,
                          width: 386,
                        }}
                      >
                        <RadioGroup
                          name="tiers"
                          value={selectedOption}
                          onChange={handleOptionChange}
                          sx={{ gap: 1, "& > div": { p: 1 } }}
                        >
                          <FormControl>
                            <Radio
                              className="text-align-left"
                              overlay
                              value="email"
                              label="Email"
                            />
                            <FormHelperText>
                              Receive verification code via Email.
                            </FormHelperText>
                          </FormControl>
                        </RadioGroup>
                      </Sheet>
                      <Sheet
                        variant="outlined"
                        sx={{
                          boxShadow: "sm",
                          borderRadius: "sm",
                          p: 1,
                          width: 386,
                        }}
                      >
                        <RadioGroup
                          name="tiers"
                          value={selectedOption}
                          onChange={handleOptionChange}
                          sx={{ gap: 1, "& > div": { p: 1 } }}
                        >
                          <FormControl>
                            <Radio
                              className="text-align-left"
                              overlay
                              value="sms"
                              label="Mobile SMS"
                            />
                            <FormHelperText>
                              Receive verification code via Mobile.
                            </FormHelperText>
                          </FormControl>
                        </RadioGroup>
                      </Sheet>
                    </div>
                    <div className="justify-content-flex-end">
                      <div className="next-button-container">
                        {/* <Link to="/digital-identity" className="Link-white-text"> */}
                        {/* <button className={`skip-btn ${selectedOption !== null ? 'hidden' : ''}`}>
                      SKIP
                    </button> */}
                        {/* </Link> */}
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          onClick={handleAuthNextPage}
                          disabled={selectedOption === null || validNextFor2FA}
                          className={`next-btn ${selectedOption === null || validNextFor2FA
                            ? "disabled"
                            : ""
                            }`}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </>
                )}

                {TwoFactorAuthSecondPage && !TwoFactorAuthFirstPage && (
                  <div>
                    {/* <h2 className="header_align">Enable 2FA (Two-factor Authentication)</h2>
                  <p className="paragraph-text">Enter the Code </p> */}
                    <div className="dialogContainer1">
                      <div>
                        <TextField
                          type={showCode ? "text" : "password"}
                          value={code}
                          onChange={handleCodeChange}
                          error={showCodeError}
                          helperText={showCodeError ? "Code is required" : ""}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault(); // Prevent the default Enter behavior
                              handleCodeSubmit(); // Trigger the submit function
                            }
                          }}
                          disabled={minutes === 0 && seconds === 0}
                          className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""
                            }`}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={toggleCodeVisibility}>
                                  {showCode ? (
                                    <VisibilityIcon />
                                  ) : (
                                    <VisibilityOffIcon />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {errorMessage ? (
                          <div
                            style={{
                              color: "red",
                              marginTop: "10px",
                              minHeight: "20px",
                            }}
                          >
                            {errorMessage || "\u00A0"}
                          </div>
                        ) : (
                          // <div style={{ marginTop: '10px' }}>
                          // </div>
                          <></>
                        )}
                      </div>

                      <div className="justify-content-space-bw-login mt-20">
                        <div className="resent-otp">
                          <span className="timer-label">Remaining Time: </span>
                          <span className="timer-value">
                            {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                          </span>
                        </div>

                        <div
                          className="next-button-container"
                          style={{ gap: "16px" }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={handleCodeSubmit}
                            disabled={code.trim() === ""}
                            className={`next-btn ${code.trim() === "" ? "disabled" : ""
                              }`}
                          >
                            Next
                          </Button>
                        </div>
                      </div>
                      <div className="resent-otp-design mt-20">
                        Didn't get the mail?{" "}
                        <button
                          className="button-style-height"
                          onClick={resendOTP}
                        >
                          RESEND
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* </DialogContentText> */}
            </DialogContent>
          </Dialog>
        )}

        {isVerifiedDialogOpen && (
          <>
            <Dialog
              open={isVerifiedDialogOpen}
              // onClose={handleCloseVerifiedDialog}
              // onClick={handleCloseVerifiedDialog}
              disableBackdropClick
              disableEscapeKeyDown
              aria-labelledby="Enable 2FA (Two-factor Authentication)"
              aria-describedby="alert-dialog-description"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent default Enter behavior
                  handleContinuetoDigital(); // Trigger the function
                }
              }}
            >
              <DialogContent className="dialogContainer1">
                <DialogContentText className="dialogText">
                  <div className="flex flex-col items-center justify-center text-center">
                    <img
                      src={Tick}
                      alt="Verification"
                      className="dialogImage"
                    />
                    <p className="mt-10" >
                      Your Two-factor Authentication is Successful !
                    </p>

                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#0044C6", width: "100%" }}
                      onClick={handleContinuetoDigital}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent the default Enter behavior
                          handleContinuetoDigital(); // Trigger the submit function
                        }
                      }}
                    >
                      Continue
                    </Button>
                  </div>
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </>
        )}

        {isPageNotVerified && (
          <>
            <Dialog
              open={isPageNotVerified}
              // onClose={handleCloseVerifiedDialog}
              onClick={handleCloseVerifiedDialog}
              disableBackdropClick
              disableEscapeKeyDown
              aria-labelledby="Enable 2FA (Two-factor Authentication)"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent className="dialogContainer">
                <DialogContentText className="dialogText">
                  <div className="justify-content-center-1">
                    <img
                      src={Warning}
                      alt="Verification"
                      className="dialogImage"
                    />
                    <p className="mt-10">
                      Your Two-factor Authentication is not Successful{" "}
                    </p>
                    <div className="mt-10 next-button-container">
                      <button
                        className={`next-btn`}
                        type="submit"
                        onClick={handleRetrybutton}
                      >
                        RETRY
                      </button>
                    </div>
                  </div>
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </>
        )}
        {showCaptcha && <Captcha />}
      </div>
    </>
  );
}

export default Login;
